// Core AGZ Experiment PDPs
export const AGZ_PDP_EXPERIMENT_CONTROL_PDP = '/product/sleep-supplement';
export const AGZ_PDP_EXPERIMENT_VARIANT_PDP = '/product/sleep-supplement-one-time-purchase';
// Pages the AGZ Klaviyo modal should fire on
export const AGZ_PDP_EXPERIMENT_KLAVIYO_MODAL_PAGES = [
  AGZ_PDP_EXPERIMENT_CONTROL_PDP,
  AGZ_PDP_EXPERIMENT_VARIANT_PDP,
  '/sleep/agz',
  '/shop/sleep-support',
  '/sleep/agz-ingredients',
  '/recipes/agz',
  '/quality-standards/agz'
];
